import { ExternalDocumentPacketExportReason } from 'primary-schema';

import {
  BlockSelectField,
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../ConfigFields/SelectField';
import { BlockTextField } from '../../ConfigFields/TextField';

const EXPORT_REASONS = Object.values(ExternalDocumentPacketExportReason);

export function ExportExternalDocumentPacketFormFields() {
  return (
    <>
      <ParentBlockSelectField
        fieldName="config.externalDocumentPacket.sourceBlockName"
        label="Document to Export"
        required
        helperText={getSourceBlockNameHelperText('External Document Packet')}
      />
      <BlockSelectField
        fieldName="config.exportReason"
        label="Export Reason"
        options={EXPORT_REASONS.map((reason) => ({
          label: reason,
          value: reason,
        }))}
        required
      />
      <BlockTextField
        fieldName="config.filePath"
        label="Export Path"
        helperText="Relative path to export the document to. If not provided, default path based on export reason will be used."
      />
    </>
  );
}
